// #3496 -- which scoreadmin-fe API calls can change a Score Admin badge count
// (Needs placings, Can't place yet, Review Queue), and therefore call
// refreshBadges() when they succeed.
//
// The rule is "refresh unless listed here". A new mutation that nobody
// classifies refreshes (one cheap GET /show/:showId/badge-counts) rather than
// silently leaving a badge stale; only a call that provably cannot move a count
// is listed, with its reason.
//
// Matched by generated-client METHOD NAME (the operationId), wired once in
// useScoreApi (scoreApi.js), so every page that calls the API gets it, with no
// per-call-site `refreshBadges()` to forget.

// Reads that are not spelled get*/list*.
export const READ_ONLY_CALLS = {
  batchRideStatus: "POST body carries ride ids; a read of derived statuses",
  resolveJudgeComposite: "resolves a judge id to its composite members; a lookup (RideEditor calls it in a loop)",
  resolveClassByNumber: "looks a class up by its number; a lookup",
  previewPlaceClassByRules: "dry run of the auto-placer (#3567), writes nothing",
  checkSheetManifest: "compares a sheet manifest to what is stored; a check, writes nothing",
};

// Writes that cannot change a count, with the reason.
export const NEUTRAL_MUTATIONS = {
  setRingState: "ring display state, no ride/class status or review item",
  clearRingState: "ring display state, no ride/class status or review item",
  setShowSectionSettings: "show display setting",
  setShowSponsorPrizeSettings: "show display setting, what prints on a report",
  setShowScribeUnlockPin: "scribe tablet PIN",
  setShowNoFoxbox: "show flag for the on-prem sync, not a count input",
  setShowLogo: "show branding",
  setShowFriendlyName: "show name",
  addScoreSheetAnnotation: "free-text note on a sheet, not a mark or a status",
  putScoreSheetDraft: "an unsaved draft is never counted",
  discardScoreSheetDraft: "an unsaved draft is never counted",
  putSponsor: "scoreboard sponsor library",
  deleteSponsor: "scoreboard sponsor library",
  putInstanceConfig: "foxbox instance config",
  putJudgeSignature:
    "the judge's signature image on file (org level); a ride is signed by signScoreSheetPanel / completeScoreSheet, which do refresh",
  deleteJudgeSignature: "the judge's signature image on file (org level)",
  setClassFriendlyName: "class display name",
  setClassSponsorship: "class sponsor text",
  setClassSponsorPrizeDisplay: "class display switches, what prints on a report",
  setClassSkipUsefUpload: "USEF upload flag, not a count input",
  setClassDshbKindOverride: "USEF kind label, not a count input",
  setClassScribeAssignment: "which scribe is assigned, no ride/class status",
};

/** True when a successful call to the named client method should refresh the badges. */
export function shouldRefreshBadges(methodName) {
  if (typeof methodName !== "string") return false;
  if (/^(get|list)/.test(methodName)) return false;
  if (Object.hasOwn(READ_ONLY_CALLS, methodName)) return false;
  if (Object.hasOwn(NEUTRAL_MUTATIONS, methodName)) return false;
  return true;
}
